import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import AnalyticsChartDoughnut from '@/client/components/_atoms/analytics_chart_doughnut'
import CsvDownload from '@/client/components/_atoms/csv_download'

import { InstagramInstantwinEnqueteAnswer, InstagramInstantwinEnqueteQuestion } from '../types'

interface Props {
  prizeId: number | null
  questions: InstagramInstantwinEnqueteQuestion[]
  selectedId: number | null
  answers: InstagramInstantwinEnqueteAnswer[]
  totalCount: number
  campaignName: string
  loading: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramInstantwinCampaignAnalyticsEnqueteTab',
  props: {
    prizeId: null,
    questions: null,
    selectedId: null,
    answers: null,
    totalCount: null,
    campaignName: null,
    loading: { type: Boolean }
  },
  emits: ["select-question"],
  setup(__props: any, { emit }: { emit: ({ (e: 'select-question', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  prizeId: number | null
  questions: InstagramInstantwinEnqueteQuestion[]
  selectedId: number | null
  answers: InstagramInstantwinEnqueteAnswer[]
  totalCount: number
  campaignName: string
  loading: boolean
};





const hasQuestions = computed(() => props.questions.length > 0)
const hasAnswers = computed(() => props.answers.length > 0)

const sortedAnswers = computed(() => {
  return props.answers
    .map((answer, index) => ({ answer, index }))
    .sort((a, b) => {
      if (b.answer.count !== a.answer.count) {
        return b.answer.count - a.answer.count
      }
      return a.index - b.index
    })
    .map(item => item.answer)
})

const chartData = computed(() => sortedAnswers.value.map(answer => ({ label: answer.label, count: answer.count })))
const chartSize = computed(() => {
  const baseSize = Math.max(360, props.answers.length * 28)
  return Math.min(baseSize, 420)
})

const chartStyles = computed(() => ({
  width: `${chartSize.value}px`,
  height: `${chartSize.value}px`,
  margin: '0'
}))

const chartColors = [
  'rgba(189,189,189,0.8)',
  'rgba(92,107,192,0.8)',
  'rgba(2,119,189,0.8)',
  'rgba(38,166,154,0.8)',
  'rgba(255,167,38,0.8)',
  'rgba(239,83,80,0.8)',
  'rgba(242, 91,141,0.8)',
  'rgba(188,42,141,1)',
  '#F8E91A',
  '#6FA626',
  '#59F0EB',
  '#BC782A',
  '#7D2ABC'
]

const legendItems = computed(() => {
  return sortedAnswers.value.map(answer => {
    const percent = props.totalCount ? Math.round((answer.count / props.totalCount) * Math.pow(100, 2)) / 100 : 0
    return { ...answer, percent }
  })
})

const handleQuestionChange = (value: number) => {
  emit('select-question', value)
}

const resolveLegendColor = (optionId: number) => {
  const index = sortedAnswers.value.findIndex(answer => answer.optionId === optionId)
  return chartColors[index % chartColors.length] ?? chartColors[0]
}

const formatLegendLabel = (item: InstagramInstantwinEnqueteAnswer & { percent: number }) => {
  return `${item.label}：${item.count.toLocaleString()}人(${item.percent}%)`
}

const downloadCsv = () => {
  if (!hasAnswers.value) {
    return { error: 'NO_DATA' }
  }

  const questionText = props.questions.find(question => question.id === props.selectedId)?.text || 'アンケート'
  const normalized = questionText.replace(/[\\/:*?"<>|]/g, '_')
  const filename = `${props.campaignName}_${normalized}`

  const data: Array<Array<string | number | null>> = []
  data.push(['回答', '回答数', '割合'])

  legendItems.value.forEach(item => {
    data.push([item.label, item.count, item.percent])
  })

  return { filename, data }
}

return { __sfc: true,props, emit, hasQuestions, hasAnswers, sortedAnswers, chartData, chartSize, chartStyles, chartColors, legendItems, handleQuestionChange, resolveLegendColor, formatLegendLabel, downloadCsv, AnalyticsChartDoughnut, CsvDownload }
}

})